import { createContext } from 'react';
export var WidgetEnvironmentContext = createContext(null);
export var WidgetEnvironmentProvider = WidgetEnvironmentContext.Provider;
export var WidgetEnvironmentConsumer = WidgetEnvironmentContext.Consumer;
//# sourceMappingURL=EnvironmentProvider.js.map